module.exports = __webpack_public_path__ + "img/youtube.ed1bdab0.png";